import React from 'react'
import { Icon, SemanticICONS } from 'semantic-ui-react'

import ArchidektDropdown from 'components/elements/ArchidektDropdown'
import ContextMenu from 'components/elements/ContextMenu'
import { Option } from 'components/elements/ArchidektDropdown/types'

import styles from './phatDropdown.module.scss'

export type Props = {
  value: any
  header?: React.ReactNode
  icon?: SemanticICONS
  options: Option[]
  extraOptions?: Option[]
  selectedLabel?: React.ReactNode
  className?: string
  triggerClassName?: string
  triggerWrapperClassName?: string
  menuClassName?: string
  extraOptionsElement?: React.ReactNode
  disabled?: boolean
  inlineHeader?: boolean
  placeholder?: string
  onFocus?: () => void
  asteriskLabel?: string
  fixedMenu?: boolean
}

const PhatDropdown = ({
  header,
  options,
  icon,
  value,
  extraOptions,
  extraOptionsElement = null,
  selectedLabel = null,
  className = '',
  triggerClassName = '',
  triggerWrapperClassName = '',
  menuClassName,
  disabled = false,
  inlineHeader = false,
  placeholder,
  asteriskLabel,
  fixedMenu,
  onFocus,
}: Props) => {
  const Menu = fixedMenu ? ContextMenu : ArchidektDropdown

  return (
    <div className={`${styles.container} ${inlineHeader ? styles.inlineContainer : ''} ${className}`}>
      {header && <label className={`${styles.header} ${inlineHeader ? styles.inlineHeader : ''}`}>{header}</label>}

      <Menu
        openOnLeftClick
        disabled={disabled}
        onFocus={onFocus}
        options={options}
        menuClassName={`${fixedMenu ? styles.fixedMenu : styles.menu} ${menuClassName}`}
        triggerClassName={`${styles.triggerWrapper} ${triggerWrapperClassName}`}
        className={`${styles.triggerWrapper} ${triggerWrapperClassName}`}>
        <button
          disabled={disabled}
          className={`
          ${styles.trigger}
          ${extraOptions || extraOptionsElement ? styles.hasExtraOptions : ''}
          ${triggerClassName}
        `}
          type="button">
          <span className={styles.leftContent}>
            {icon && <Icon name={icon} className={styles.icon} />}
            {!selectedLabel && value !== undefined && (
              <>
                {/* @ts-ignore */}
                {options.find(o => `${o.id}` === `${value}`)?.label || null}
              </>
            )}
            {selectedLabel}
            {placeholder && !value && <span className={styles.placeholder}>{placeholder}</span>}
          </span>
          <Icon name="triangle down" />
        </button>
      </Menu>

      {asteriskLabel && <label className={styles.asteriskLabel}>{asteriskLabel}</label>}

      {!!extraOptions && (
        <Menu options={extraOptions}>
          <button className={styles.extraTrigger} type="button">
            <Icon name="cog" />
          </button>
        </Menu>
      )}

      {extraOptionsElement}
    </div>
  )
}

export default PhatDropdown
